// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__fkkoq","header":"ClearentDisclaimer_header__2rkM7","inner":"ClearentDisclaimer_inner__1RGpo"};